// File Storage API Types

// Folder type for filtering
export type FolderType = "all" | "integration" | "migration";

// Request Types
export interface GetFileSystemRequest {
  prefix: string;
  continuation_token: string | null;
  search: string | null;
  limit: number | null;
  folder_type?: FolderType;
  page?: number;
  sort_field?: "name" | "date";
  sort_order?: "asc" | "desc";
}

export interface DownloadFileRequest {
  source: string;
  fileName: string;
}

export interface DownloadArchiveRequest {
  source: string;
  fileName: string;
}

// Response Types
export interface FileSystemResponse {
  continuation_token: string | null;
  folders: FileItem[];
  show_filter: boolean | null;
  total_count?: number;
  total_pages?: number;
  current_page?: number;
  has_direct_files?: boolean;
}

export interface FileItem {
  fname: string;
  ftype: string;
  fsource: string;
  last_modified?: string;
  file_count?: number;
  /** Number of subfolders (for folder items) */
  subfolder_count?: number;
  /** Number of files directly in this folder (for folder items) */
  direct_file_count?: number;
}

export interface DownloadFileResponse {
  next_token: string | null;
  file_urls: string[];
}

export interface DownloadArchiveErrorResponse {
  error: string;
}

export interface DownloadArchiveUrlResponse {
  download_url: string;
  filename: string;
}

// Union type for archive responses
export type DownloadArchiveResponse = Blob | DownloadArchiveErrorResponse | DownloadArchiveUrlResponse;

// Type guard functions
export const isDownloadArchiveError = (response: DownloadArchiveResponse): response is DownloadArchiveErrorResponse => {
  return typeof response === 'object' && response !== null && 'error' in response;
};

export const isDownloadArchiveBlob = (response: DownloadArchiveResponse): response is Blob => {
  return response instanceof Blob;
};

export const isDownloadArchiveUrl = (response: DownloadArchiveResponse): response is DownloadArchiveUrlResponse => {
  return typeof response === 'object' && response !== null && 'download_url' in response;
};
